import ButtonsInList from './ButtonsInList';

export default {
  edit: {},
  list: {
    buttons: ButtonsInList,
  },
};
